"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantityInput = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_visually_hidden_1 = require("@hopin-team/ui-visually-hidden");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var input_1 = require("../styled/input");

var QuantityInput = (0, react_1.forwardRef)(function (_a, ref) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      ariaLabel = _a["aria-label"],
      ariaLiveAnnouncement = _a.ariaLiveAnnouncement,
      rest = tslib_1.__rest(_a, ["className", "__UIScope", 'data-testid', 'aria-label', "ariaLiveAnnouncement"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'QuantityInput',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _b = (0, react_1.useContext)(context_1.QuantityFieldContext),
      fieldId = _b.fieldId,
      hasSpinButton = _b.hasSpinButton;

  if (hasSpinButton) {
    rest.role = 'spinbutton';
  }

  return react_1.default.createElement("div", {
    "aria-live": "assertive",
    "aria-atomic": "true"
  }, react_1.default.createElement(input_1.Input, tslib_1.__assign({
    id: fieldId,
    className: rootClasses,
    "data-testid": testID,
    "aria-label": ariaLabel,
    ref: ref,
    type: "number",
    hasSpinButton: hasSpinButton
  }, rest)), react_1.default.createElement(ui_visually_hidden_1.VisuallyHidden, null, ariaLiveAnnouncement));
});
QuantityInput.displayName = 'QuantityInput';
var QuantityInputWithSpace = (0, ui_helper_with_space_1.withSpace)(QuantityInput);
exports.QuantityInput = QuantityInputWithSpace;